"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrB2bForgotPassword = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const fdr_lib_ident_with_auth_1 = require("@hotelplan/fdr.lib.ident.with-auth");
const fdr_regular_fusion_fdr_auth_form_overlay_1 = require("@hotelplan/fdr.regular.fusion.fdr-auth-form-overlay");
const fdr_b2b_forgot_password_styles_1 = require("./fdr-b2b-forgot-password.styles");
const fdr_forgot_password_form_1 = require("./fdr-forgot-password-form");
var RequestStatusType;
(function (RequestStatusType) {
    RequestStatusType["SUCCESS"] = "success";
    RequestStatusType["ERROR"] = "error";
})(RequestStatusType || (RequestStatusType = {}));
const FdrForgotPasswordValidationSchema = Yup.object({
    username: Yup.string().required('forms:errors.required'),
});
function getForgotPasswordResultNotification(status) {
    return {
        [RequestStatusType.SUCCESS]: {
            type: components_common_modals_1.NotificationType.SUCCESS,
            title: `auth:b2b.forgotPassword.success.title`,
            text: `auth:b2b.forgotPassword.success.text`,
        },
        [RequestStatusType.ERROR]: {
            type: components_common_modals_1.NotificationType.ERROR,
            title: `auth:b2b.forgotPassword.failure.title`,
            text: `auth:b2b.forgotPassword.failure.text`,
        },
    }[status];
}
function FdrB2bForgotPassword({ isShown, forgotPasswordLabel, onClose, }) {
    const [t] = (0, next_i18next_1.useTranslation)(['auth']);
    const { client } = (0, fdr_lib_ident_with_auth_1.useAuthContext)();
    const [forgotPasswordStatus, setForgotPasswordStatus] = (0, react_1.useState)(undefined);
    const forgotPasswordRequestNotificationData = forgotPasswordStatus
        ? getForgotPasswordResultNotification(forgotPasswordStatus)
        : null;
    function handleFormSubmit(values, helpers) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { error } = yield client.b2bForgotPassword(values.username);
                setForgotPasswordStatus(error ? RequestStatusType.ERROR : RequestStatusType.SUCCESS);
                onClose();
            }
            catch (e) {
                setForgotPasswordStatus(RequestStatusType.ERROR);
            }
            finally {
                helpers.resetForm();
            }
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fdr_b2b_forgot_password_styles_1.FdrB2bForgotPasswordModal, { title: t('auth:b2b.forgotPassword.title'), show: isShown, onClose: onClose },
            react_1.default.createElement(fdr_regular_fusion_fdr_auth_form_overlay_1.FdrAuthFormOverlay, { text: t('auth:b2b.forgotPassword.text') },
                react_1.default.createElement(fdr_forgot_password_form_1.FdrForgotPasswordForm, { usernameLabel: forgotPasswordLabel, onSubmit: handleFormSubmit, validationSchema: FdrForgotPasswordValidationSchema }))),
        forgotPasswordRequestNotificationData ? (react_1.default.createElement(fdr_b2b_forgot_password_styles_1.FdrB2bForgotPasswordNotificationModal, { show: !!forgotPasswordStatus, name: "forgotPasswordRequestResultModal", type: forgotPasswordRequestNotificationData.type, title: t(forgotPasswordRequestNotificationData.title), onClose: () => setForgotPasswordStatus(undefined) }, t(forgotPasswordRequestNotificationData.text))) : null));
}
exports.FdrB2bForgotPassword = FdrB2bForgotPassword;
//# sourceMappingURL=fdr-b2b-forgot-password.js.map